/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        // Raster fallbacks for older browsers
        if (!Modernizr.svg) {
          $('.svg-fallback').each(function() {
            $(this).attr('src', $(this).data('fallback'));
          });
        }
        // Add background images
        $('[data-bg-image]').each(function() {
          console.log($(this).data('bg-image'));
          $(this).css('background-image', 'url(' + $(this).data('bg-image') + ')');
        });
        if (UTIL.isScreenXs()) {
          skrollrTop = 0;
          // Set mobile-pane heights
          $('.mobile-pane').height($(window).height());
          // Toggle mobile nav and search
          $('[data-action="toggle-mobile-pane"]').on('click', function(ev) {
            ev.preventDefault();
            // Close any open panes then open clicked pane
            Sage.common.closeMobilePanes(this);
          });
        } else {
          // Mini banner
          $(window).scroll(function() {
            Sage.common.miniNavbar();
          });
          Sage.common.miniNavbar();
        }
        // Initialize Tooltips
        $('[data-toggle="tooltip"]').tooltip();
        // Equalize elements
        // Sample: data="equalize,innerHeight|children,.padder|devices,sm:md:lg"
        $('[data-equalize]').each(function() {
          var parent = $(this);
          // Wait until images are loaded
          parent.imagesLoaded(function() {
            // Declare empty options array
            var s = [];
            // Loop over each data attribute
            $.each(parent.data(), function(k,v) {
              s.push(k + ':' + v);
            });
            // Parse options (needed if value is integer or bool)
            var options = UTIL.parse_options(s.join('|'));
            // Which devices to execute this on?
            var devices;
            if (parent.data('devices')) {
              devices = parent.data('devices').split(':');
            } else {
              devices = ['xs', 'sm', 'md', 'lg'];
            }
            // Equalize with options
            if (UTIL.isScreenXs() && devices.indexOf('xs') !== -1) {
              parent.equalize(options);
            }
            if (UTIL.isScreenSm() && devices.indexOf('sm') !== -1) {
              parent.equalize(options);
            }
            if (UTIL.isScreenMd() && devices.indexOf('md') !== -1) {
              parent.equalize(options);
            }
            if (UTIL.isScreenLg() && devices.indexOf('lg') !== -1) {
              parent.equalize(options);
            }
          });
        });
        // Validate Discount
        validating_discount = false;
        $('#rcp_discount_code').keyup(function(key) {
          if(key.which !== 13) {
            Sage.common.validate_discount($(this).val());
          }
        });
        // Initiate skrollr if #skrollr-body exists
        if ($("#skrollr-body").length) {
          // Move fixed elements outside of #skrollr-body
          $('.parallax-wrapper').each(function() {
            $(this).insertBefore($('#skrollr-body'));
          });
          // Remove videos from mobile devices
          if (Modernizr.touch) {
            $('.parallax-wrapper').each(function() {
              $(this).find('.parallax-video-container').remove();
            });
          }
          // Initiate skrollr
          Skrollr = Sage.common.initSkrollr();
          // Initiate skrollr-menu
          skrollr.menu.init(Skrollr);
          // Refresh skrollr (fixes whitespace bug)
          setTimeout(function() {
            Skrollr.refresh();
          }, 1000);
          // Auto play any videos when parallax is active
          $('.parallax-wrapper').each(function() {
            $(this).find('video').each(function() {
              this.play();
            });
          });
          // Create scroll trigger
          var $scrollTrigger = $('<div class="scroll-trigger"><span class="icon-angle-down"></span></div>');
          $('#skrollr-body').after($scrollTrigger);
          $scrollTrigger.on('click', function() {
            // Scroll to window height - navbar mini height
            Skrollr.animateTo($(window).height() - 80, {
              done: function() {
                // Hide scroll trigger when done
                UTIL.fadeOutElement($scrollTrigger);
              }
            });
          });
          // Hide scroll trigger when scrolled past
          $(window).scroll(function() {
            if ($(this).scrollTop() >= $(window).height() - 80) {
              UTIL.fadeOutElement($scrollTrigger);
            }
          });

          if (Skrollr.isMobile()) {
            Skrollr.on('render', function() {
              // Hide scroll trigger
              if (Skrollr.getScrollTop() >= $(window).height() - 80) {
                UTIL.fadeOutElement($scrollTrigger);
              }
            });
          }
        }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
      miniNavbar: function() {
        if ($(window).scrollTop() >= 300) {
          $('.banner, .toolbar-wrap').addClass('mini');
        } else {
          $('.banner, .toolbar-wrap').removeClass('mini');
        }
      },
      initSkrollr: function() {
        s = skrollr.init({
          smoothScrolling: false,
          mobileDeceleration: 0.004,
          forceHeight: false
        });
        return s;
      },
      closeMobilePanes: function(el) {
        $('[data-action="toggle-mobile-pane"]').each(function() {
          // If clicked element is not the current element slideUp
          if (this !== el && $(this).hasClass('active')) {
            $(this).removeClass('active');
            $($(this).data('target')).removeClass('active');
            $($(this).data('target')).slideUp();
          } else if (this === el) {
            Sage.common.toggleMobilePane(el);
          }
        });
      },
      toggleMobilePane: function(el) {
        if ($(el).hasClass('active')) {
          $(el).removeClass('active');
          $($(el).data('target')).removeClass('active');
          $($(el).data('target')).slideUp();
          // Re-initiate skrollr
          if ($("#skrollr-body").length) {
            Skrollr = Sage.common.initSkrollr();
            Skrollr.animateTo(skrollrTop);
          }
        } else {
          $(el).addClass('active');
          $($(el).data('target')).addClass('active');
          $($(el).data('target')).slideDown({
            complete: function() {
              // Destroy Skrollr (hi-jacks scrolling on touch devices)
              if (typeof(Skrollr) !== "undefined") {
                skrollrTop = Skrollr.getScrollTop();
                Skrollr.destroy();
              }
            }
          });
        }
      },
      validate_discount: function() {

        if( validating_discount ) {
          // return;
        }

        var $ = jQuery;
        var gateway_fields = $('.rcp_gateway_fields');
        var discount = $('#rcp_discount_code').val();
        var $inputGroupAddon = $('#rcp_discount_code_wrap .input-group-addon.discount-validation');
        var $discountFieldGroup = $('#rcp_discount_code_wrap');
        var $originalPrice = $('.rcp_price');
        var $discountedPrice = $('<span class="discounted-price"></span>');
        var subscription = '';

        if( $('input[name="rcp_level"]').length ) {

          subscription = $('input[name="rcp_level"]').val();

        } else {

          subscription = $('#rcp_subscription_levels input:checked').val();

        }

        if( ! discount ) {
          return;
        }

        var data = {
          action: 'validate_discount',
          code: discount,
          subscription_id: subscription
        };

        validating_discount = true;

        $.post(rcp_script_options.ajaxurl, data, function(response) {

          if( ! response.valid ) {

            // code is invalid
            $discountFieldGroup.removeClass('has-success').addClass('has-error');
            $originalPrice.removeClass('text-strike');
            $('.discounted-price').remove();
            $inputGroupAddon.html('Invalid');

          } else if( response.valid ) {

            // code is valid
            $discountFieldGroup.removeClass('has-error').addClass('has-success');
            $inputGroupAddon.html('Valid <strong>' + response.amount + '</strong> off!');
            if (response.amount.indexOf('%') >= 1) {
              var percent = parseInt(response.amount.replace('%', '')) / 100;
              var original = parseFloat($('.rcp_price').text().replace('$', ''));
              var discountedPrice = Math.round((original - (original * percent)) * 100) / 100;
              $discountedPrice.text(' $' + discountedPrice).insertAfter($originalPrice);
              $originalPrice.addClass('text-strike');
            }
            if( response.full ) {

              $('#rcp_auto_renew_wrap').hide();
              gateway_fields.hide().addClass('rcp_discounted_100');
              $('#rcp_gateway_extra_fields').remove();

            } else {
              
              $('#rcp_auto_renew_wrap').show();
              gateway_fields.show().removeClass('rcp_discounted_100');
            
            }

          }

          validating_discount = false;
          $('body').trigger('rcp_discount_applied', [ response ] );

        });
      }
    },
    'home': {
      init: function() {

      },
      finalize: function() {
        setTimeout(function() {
          $('.intro-hero h1').addClass('appear');
        }, 200);
        setTimeout(function() {
          $('.intro-hero p:nth-of-type(1)').addClass('appear');
        }, 1000);
        setTimeout(function() {
          $('.intro-hero p:nth-of-type(2)').addClass('appear');
        }, 2000);
        setTimeout(function() {
          $('.intro-hero .btn').addClass('appear');
        }, 4000);
        setTimeout(function() {
          $('.intro-hero .col-sm-4').addClass('appear');
        }, 3000);
      }
    },
    'login': {
      init: function() {
        if (!UTIL.isScreenXs()) {
          $('.main').height($(window).height() - $('.banner').height() - $('.content-info').height() - 80);
        }
      },
      finalize: function() {

      }
    },
    'account': {
      init: function() {
      },
      finalize: function() {
        if (window.location.search.indexOf('card=') >= 1) {
          $('.main .nav-tabs li:eq(2) a').tab('show');
        } else if(window.location.search.indexOf('updated=') >= 1) {
          $('.main .nav-tabs li:eq(1) a').tab('show');
        }
      }
    },
    'portfolio': {
      init: function() {
        var loader = $('.plot').html();
        $('.plot').each(function() {
          Sage.portfolio.drawPlot(this);
        });
        $('.plot-filter').on('click', function() {
          $('.plot-filter').removeClass('active');
          $(this).addClass('active');
          $($(this).data('target')).html(loader);
          $('.loader').loader();
          $($(this).data('target')).data('portfolio', $(this).data('portfolio')).data('sp500', $(this).data('sp500'));
          Sage.portfolio.drawPlot($(this).data('target'));
        });
      },
      drawPlot: function(el) {
        var portfolio;
        var sp500;
        var container = el;
        var plot_data;
        var plot;
        var options;
        $.getJSON($(container).data('portfolio'), function(data) {
          portfolio = data;
        }).complete(function() {
          $.getJSON($(container).data('sp500'), function(data) {
            sp500 = data;
          }).complete(function() {
            options = {
              xaxis: {
                mode: 'time'
              },
              series: {
                lines: {
                  lineWidth: 1
                },
                shadowSize: 0
              },
              colors: [
                '#1c3d54',
                '#efa130'
              ],
              legend: {
                position: 'nw'
              }
            };
            plot_data = [{ label: "S&P 500", data: sp500 }, { label: $(container).data('title'), data: portfolio }];
            plot = $.plot(container, plot_data, options);
          });
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  UTIL = {
    screenXs: 480,
    screenSm: 768,
    screenMd: 992,
    screenLg: 1200,
    fire: function(func, funcname, args) {
      var fire;
      var namespaces = [Sage, Portfolios];
      for (var i in namespaces) {
        var namespace = namespaces[i];
        funcname = (funcname === undefined) ? 'init' : funcname;
        fire = func !== '';
        fire = fire && namespace[func];
        fire = fire && typeof namespace[func][funcname] === 'function';

        if (fire) {
          namespace[func][funcname](args);
        }
      }
    },
    loadEvents: function() {
      // Get scrollbar width
      $('body, html').css('overflow', 'hidden');
      var screenWidth1 = $(window).width();
      $('body, html').css('overflow', 'visible');
      var screenWidth2 = $(window).width();
      scrollbarWidth = screenWidth1 - screenWidth2;

      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');

    },
    isScreenXs: function() {
     if ($(window).width() < this.screenSm - scrollbarWidth) {
        return true;
      }
      return false;
    },
    isScreenSm: function() {
      if ($(window).width() < this.screenMd && $(window).width() >= this.screenSm - scrollbarWidth) {
        return true;
      }
      return false;
    },
    isScreenMd: function() {
      if ($(window).width() < this.screenLg && $(window).width() >= this.screenMd - scrollbarWidth) {
        return true;
      }
      return false;
    },
    isScreenLg: function() {
      if ($(window).width() >= this.screenLg - scrollbarWidth) {
        return true;
      }
      return false;
    },
    fadeOutElement: function(el) {
      el.animate({
        opacity: 0
      }, 300);
    },
    parse_options: function(string, optionsObj) {
      if (typeof(optionsObj) === 'undefined') {
        optionsObj = {};
      }
      // Define option
      var options = string.split('|');
      // Loop through each option (see php template for correct data attribute format)
      for (i = 0; i < options.length; i++ ) {
        // Split each option in to property name and value
        var data = options[i].split(':');
        var val = data[1];
        var prop = data[0];
        if (!isNaN(val)) {  // If value is int
          optionsObj[prop] = parseInt(val);
        } else if (val === "false") { // If val is bool (false)
          optionsObj[prop] = false;
        } else if (val === "true") { // if val is bool (true)
          optionsObj[prop] = true;
        } else { // Assign value if string
          optionsObj[prop] = val;
        }
      }
      return optionsObj;
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
